/**
 * @file
 * Adds slideshow on pricing blocks.
 * For medium and down sizes.
 */

const $context = $('.pricing-plan-mobile-slideshow', context);
$context.once('pricing-block-slideshow').each((index, el) => {
  const $this = $(el);
  const slideshowOptions = {
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 700,
        settings: {
          centerPadding: '130px',
        },
      },
      {
        breakpoint: 780,
        settings: {
          centerPadding: '180px',
        },
      },
    ],
  };

  const initSlideshow = () => {
    if ($(window).width() < 960) {
      if (!$this.hasClass('slick-initialized')) {
        $this.slick(slideshowOptions);
      }
      const sliderHeight = `${$this.find('.slick-track').height()}px`;
      $this.find('.pricing-plan').css('height', sliderHeight);
    } else if ($this.hasClass('slick-initialized')) {
      $this.slick('unslick');
      $this.find('.pricing-plan').css('height', '');
    }
  };

  if ($this.find('.views-row').length > 1) {
    initSlideshow();

    let timeout;
    $(window).on('resize orientationChange', () => {
      clearTimeout(timeout);
      timeout = setTimeout(initSlideshow, 200);
    });
  }
});
